module.exports = __webpack_public_path__ + "img/45600.1b29a193.jpg";